import { render, staticRenderFns } from "./StartVisitModal.vue?vue&type=template&id=c2b643ae&scoped=true&"
import script from "./StartVisitModal.vue?vue&type=script&lang=js&"
export * from "./StartVisitModal.vue?vue&type=script&lang=js&"
import style0 from "./StartVisitModal.vue?vue&type=style&index=0&id=c2b643ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b643ae",
  null
  
)

export default component.exports